'use client'

import React from 'react'

import { useCollapse } from '~/utils/hooks'

import styles from './LanguageSwitcher.module.css'
import { LanguageSwitcherButton, LanguageSwitcherList, useLanguageSwitcher } from './LanguageSwitcher.utils'

export function LanguageSwitcherMobile() {
  const api = useCollapse()

  const { options, currentLocation, onLanguageChange } = useLanguageSwitcher()

  return (
    <div {...api.getRootProps()}>
      <div className={styles.collapseSection}>
        <LanguageSwitcherButton getTriggerProps={api.getTriggerProps} location={currentLocation} open={api.open} />
      </div>
      <LanguageSwitcherList options={options} onClick={onLanguageChange} getContentProps={api.getContentProps} />
    </div>
  )
}
